export const PHYSICAL_THERAPIST_LISTING_COLOUMS = [
    'Note Type',
    'Start Date',
    'Created At'
    
]
export const PHYSICAL_THERAPIST_SORTING_DATA = {
    'Note Type': 'noteType',
    'Start Date': 'startDate',
    'Created At': 'createdAt'
}
export const PHYSICAL_THERAPIST_DATA_MAPPING = {
    'Note Type': 'noteType',
    'Start Date': 'startDate',
    'Created At': 'createdAt'
}

export const PHYSICAL_ASSESSMENT_COLUMNS = [
    'Client Name',
    'Assessment Date',
    'Note Type',
    'Created At',
]

export const PHYSICAL_ASSESSMENT_SORTING_COLUMNS = {
    'Client Name': 'clientName',
    'Assessment Date': 'assessmentDate',
    'Note Type': 'noteType',
    'Created At': 'createdAt',
}

export const PHYSICAL_ASSESSMENT_COLUMNS_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Assessment Date': 'assessmentDate',
    'Note Type': 'noteType',
    'Created At': 'createdAt',
}

